// export const url = "http://192.168.165.110:5000/api/v1";
export const url = `${process.env.REACT_APP_PUBLIC_URL}`;
// export const url = "https://api.chalkitupsa.co.za/api/v1";
